import fetch from '../httpFetch.js'
import {asyncRouterMap} from '@/router';
import qs from 'qs'
/**
 * 获取组织树
 */
let url=''
if(process.env.NODE_ENV==='development'){
  url=location.origin+'/xyjljm'
  // url='http://localhost:7000/ljm'
}
export function getOrgTree() {
    return fetch.get("/bizframe/selector/orgTree.json")
}

/**
 * 根据类型获取类别树
 *  0 : 数据字典
 *  1 : 系统参数
 *  2 : 标准字段
 *  3 : 系统资源
 *  4 : 系统菜单
 *  5 : 子系统
 */
export function getKindTree(kindType) {
    // return fetch.get("/bizframe/selector/kindTree.json?kindType="+kindType)
     return fetch.get("/getKindTree")
}

/**
 * 获取类别所有树
 */
export function getAllKindTree() {
    return fetch.get("/bizframe/selector/allKindTree.json")
}

/**
 * 获取数据字典
 * @param {字典名} dictName
 */

export function getDicts(dictName) {
    return fetch.get("/bizframe/dict/getDicts.json?dictName=" + dictName)
}

/**
 * post方式发送请求方法
 * @param {*参数} params
 * @param {*请求url} url
 */
export function post(url,params) {
    return fetch.post(url, params)
}
/**
 * get方式发送请求方法
 * @param {*参数} params
 * @param {*请求url} url
 */
export function get(url,params) {
    return fetch.get(url, {params})
}
/**
 *  获取权限列表
 */
export function getPermissionMenuTree () {
  return fetch.get("/bizframe/permissionList.json")
}
/**
 *  提交权限列表
 * @param {*参数} data
 */
export function submitPermission (data) {
  return fetch.post("/bizframe/permissionList.json", data)
}

export function getOperators(pageNum, pageSize) {
     return fetch.get("/user/list?page_num=" + pageNum + "&page_size=" + pageSize)
}

export function doResetPassword(username,userId) {
     return fetch.get("/user/reset-pwd?username="+username+"&userId="+userId)
}

export function doRemoveUser(userId) {
     return fetch.get("/user/delete?id="+userId)
}

export function doUpdateUser(user) {
    return fetch.post("/user/update",user)
}

export function doSkillAudit(skillId, putaway_state, audit_opinion){
    return fetch.post("/skill/" + skillId + "/audit", {putaway_state, audit_opinion})
}

export function getSkillTable(data) {
    return fetch.get(`/skill`,{params:data})
}

export function getSkillDetails(skillId){
    return fetch.get("/skill/" + skillId)
}
// 技能--删除
export function doDeleteSkill(skillId){
    return fetch.delete("/skill/" + skillId)
}
// 技能--获取问答列表
export function getSkillFaq(skillId,data){
    return fetch.get(`/skill/${skillId}/faq`,{params:data})
}
// 技能--复制
export function doSkillCopy(skillId,userId,data){
    return fetch.post(`/skill/${skillId}/copy/user/${userId}`,data)
}
// 实体--列表
export function getEntityTable(data){
    return fetch.get('/entity',{params:data})
}
// 实体--删除
export function doDeleteEntity(id) {
     return fetch.delete("/entity/" + id)
}
// 实体--新增
export function doAddEntity(data){
    return fetch.post("/entity", data)
}
// 实体--修改
export function doModEntity(id, data){
    return fetch.post("/entity/" + id, data)
}
// 词条--列表
export function doGetWord(data){
    return fetch.get("/entity/word",{params:data})
}
// 词条--删除
export function doDeleteWord(entityId, wordId){
    return fetch.delete("/entity/" + entityId + "/word/" + wordId)
}
// 词条--新增
export function doAddWord(entity_id,data){
    return fetch.post(`/entity/${entity_id}/word`, data)
}
// 词条--修改
export function doModWord(entity_id, word_id, data){
    return fetch.post(`/entity/${entity_id}/word/${word_id}`, data)
}
// 词条--实体库更新
export function doWordUpload(){
    return fetch.post("/entity/word/reload")
}
// 实体大类--查询列表
export function doGetEntityClasses(data){
    return fetch.get('/entity/classes', {params:data})
}
// 实体大类--新增
export function doAddEntityClasses(data){
    return fetch.post('/entity/class', data)
}
// 实体大类--删除
export function doDelEntityClasses(id){
    return fetch.delete(`/entity/class/${id}`)
}
// 实体大类--修改
export function doModEntityClasses(id,data){
    return fetch.post(`/entity/class/${id}`,data)
}
// 开发者--查询
export function getSkillSupplier(data){
    return fetch.get("/platform/user", {params:data})
}
// bot--查询
export function getBotList(data){
    return fetch.get("/bot", {params:data})
}
// bot--删除
export function doDelBot(id){
    return fetch.delete(`/bot/${id}`)
}
// bot--查询详情
export function getBotDetail(id){
    return fetch.get(`/bot/${id}`)
}
// bot统计--总体数据
export function getBotCount(data){
    return fetch.get("/stats", {params:data})
}
// 文档管理--查询文档树结构
export function getDocTree(){
    return fetch.get("/doc/tree")
}
// 文档管理--新增文档
export function addDocTree(data){
    return fetch.post("/doc",data)
}
// 文档管理--删除文档
export function delDocTree(id){
    return fetch.delete(`/doc/${id}`)
}
// 文档管理--修改文档
export function editDocTree(id,data){
    return fetch.post(`/doc/${id}`,data)
}
// 文档管理--移动文档
export function moveDocTree(data){
    return fetch.post(`/doc/move`,data)
}
// 文档管理--获取文档内容
export function getDocDetail(id){
    return fetch.get(`/doc/${id}`)
}

/*********接口管理*******************/
//分页查询系统接口
export function getAllSysUri(data) {
      return fetch.post("/sysuri/list",data);
    }

//删除系统接口
export function deleteSysUri(data) {

      return fetch.get('/sysuri/delete?id='+data);
    }
//新增系统接口
export function addSysUri(data) {

      return fetch.post("/sysuri/add",data);
    }

//根据uri查询
export function getSysUri(uri) {

      return fetch.get("/sysuri/get?uri:"+uri);
    }


//更新系统接口
export function updateSysUri(data) {

      return fetch.post('/sysuri/update',data);
    }

//分页查询模板
export function queryActivityTemplate(data){
  return fetch.post("/activity/template/queryListPage",data);
}
//删除模板
export function removeActivityTemplate(data) {
  return fetch.post('/activity/template/remove',data);
}
//增加模板
export function addActivityTemplate(data) {
  return fetch.post('/activity/template/add',data);
}
//更新模板
export function editActivityTemplate(data) {
  return fetch.post('/activity/template/edit',data);
}



//分页查询活动
export function queryActivity(data){
  return fetch.post("/activity/queryListPage",data);
}
//删除活动
export function removeActivity(data) {
  return fetch.post('/activity/remove',data);
}
//增加活动
export function addActivity(data) {
  return fetch.post('/activity/add',data);
}
//更新活动
export function editActivity(data) {
  return fetch.post('/activity/edit',data);
}

//分页简单
export function querySimpleParam(data){
  return fetch.post("/param/simple/queryListPage",data);
}
//删除简单参数
export function removeSimpleParam(data) {
  return fetch.post('/param/simple/remove',data);
}
//增加简单参数
export function addSimpleParam(data) {
  return fetch.post('/param/simple/add',data);
}
//更新简单参数
export function editSimpleParam(data) {
  return fetch.post('/param/simple/edit',data);
}




//集合参数查询
export function queryMapParam(data){
  return fetch.post("/param/map/queryListPage",data);
}
//删除集合参数
export function removeMapParam(data) {
  return fetch.post('/param/map/remove',data);
}
//增加集合参数
export function addMapParam(data) {
  return fetch.post('/param/map/add',data);
}
//更新集合参数
export function editMapParam(data) {
  return fetch.post('/param/map/edit',data);
}


//集合参数字段
export function queryMapFieldParam(data){
  return fetch.post("/param/mapfield/queryListPage",data);
}
//删除集合字段
export function removeMapFieldParam(data) {
  return fetch.post('/param/mapfield/remove',data);
}
//增加集合字段
export function addMapFieldParam(data) {
  return fetch.post('/param/mapfield/add',data);
}
//更新集合字段
export function editMapFieldParam(data) {
  return fetch.post('/param/mapfield/edit',data);
}

//分页列表
export function queryListParam(data){
  return fetch.post("/param/list/queryListPage",data);
}
//删除列表参数
export function removeListParam(data) {
  return fetch.post('/param/list/remove',data);
}
//增加列表参数
export function addListParam(data) {
  return fetch.post('/param/list/add',data);
}
//更新列表参数
export function editListParam(data) {
  return fetch.post('/param/list/edit',data);
}

//分页列表字段
export function queryListFieldParam(data){
  return fetch.post("/param/listfield/queryListPage",data);
}
//删除列表字段
export function removeListFieldParam(data) {
  return fetch.post('/param/listfield/remove',data);
}
//增加列表字段
export function addListFieldParam(data) {
  return fetch.post('/param/listfield/add',data);
}
//更新列表字段
export function editListFieldParam(data) {
  return fetch.post('/param/listfield/edit',data);
}


//分页查询参数值
export function queryListParamValue(data){
  return fetch.post("/param/listvalue/queryListPage",data);
}

//删除列表值
export function removeListParamValue(data) {
  return fetch.post('/param/listvalue/remove',data);
}
//增加列表值
export function addListParamValue(data) {
  return fetch.post('/param/listvalue/add',data);
}
//更新列表值
export function editListParamValue(data) {
  return fetch.post('/param/listvalue/edit',data);
}

//查询批次ID
// export function queryBatchIList(data) {
//   return fetch.post('/param/listvalue/queryBatchIList',data);
// }
//查询抽兑奖
export function getLotteryList(data) {
     return fetch.post('/prize/lotteryList',data);
}
//修改抽兑奖
export function editLottery(data) {
     return fetch.post('/prize/editLottery',data);
}
//添加抽兑奖
export function addLottery(data) {
     return fetch.post('/prize/addLottery',data);
}
//删除抽兑奖
export function delteLottery(data) {
     return fetch.post('/prize/deleteLottery',data);
}
//查询抽奖奖品
export function drawPrizeList(data) {
     return fetch.post('/prize/drawPrizeList',data);
}
//修改抽奖奖品
export function editDrawPrize(data) {
     return fetch.post('/prize/editDrawPrize',data);
}
//添加抽奖奖品
export function addDrawPrize(data) {
     return fetch.post('/prize/addDrawPrize',data);
}
//删除抽奖奖品
export function deleteDrawPrize(data) {
     return fetch.post('/prize/deleteDrawPrize',data);
}

/****************权益管理接口***********************/
/****************权益类型***********************/
//分页权益类型列表
export function getEquitytypeQueryListPage(data) {
     return fetch.post('/equity/equitytype/queryListPage',data);
}
//添加权益类型
export function rEquitytypeAdd(data) {
     return fetch.post('/equity/equitytype/add',data);
}
//更新权益类型
export function rEquitytypeEdit(data) {
     return fetch.post('/equity/equitytype/edit',data);
}
//删除权益类型
export function rEquitytypeRemove(data) {
     return fetch.post('/equity/equitytype/remove',data);
}
//检查权益类型编码是否存在
export function rEquitytypeCheckCodeExist(data) {
     return fetch.post('/equity/equitytype/checkCodeExist',data);
}



//获取最大事件code
export function getMaxEventCodeReq(data) {
     return fetch.post('/equity/event/getMaxEventCodeReq',data);
}
//获取最大权益code
export function getMaxEquityTypeCodeReq(data) {
     return fetch.post('/equity/equitytype/getMaxEquityTypeCodeReq',data);
}


/****************权益事件接口***********************/
//分页权益事件列表
export function getEventQueryListPage(data) {
     return fetch.post('/equity/event/queryListPage',data);
}
//添加权益事件
export function rEventAdd(data) {
     return fetch.post('/equity/event/add',data);
}
//更新权益事件
export function rEventEdit(data) {
     return fetch.post('/equity/event/edit',data);
}
//删除权益事件
export function rEventRemove(data) {
     return fetch.post('/equity/event/remove',data);
}
//检查权益事件编码是否存在
export function rEventCheckCodeExist(data) {
     return fetch.post('/equity/event/checkCodeExist',data);
}


/****************签到控台接口***********************/
//查询活动签到
export function rSelectActivitySign(data) {
     return fetch.post('/sign/selectActivitySign',data);
}
//添加活动签单设置
export function rInsertActivitySign(data) {
     return fetch.post('/sign/insertActivitySign',data);
}
//修改活动签单设置
export function rUpdateActivitySign(data) {
     return fetch.post('/sign/updateActivitySign',data);
}

//删除签到条件
export function rDeleteSignSetting(data) {
     return fetch.post('/sign/deleteActivitySign',data);
}

/****************活动用户接口***********************/

//查询用户
export function rSelectActivityUserList(data) {
     return fetch.post('/activityUser/selectActivityUserList',data);
}

//设置黑白名单
export function rSetBlackUser(data) {
     return fetch.post('/activityUser/setBlackUser',data);
}


/****************通知控台接口***********************/

//新增消息
export function rAddUsersNotice(data) {
     return fetch.post('/notice/addUsersNotice',data);
}

//新增全员消息
export function rAddAllUsersNotice(data) {
     return fetch.post('/notice/addAllUserNotice',data);
}

//查询通知
export function rNoticeQueryList(data) {
     return fetch.post('/notice/queryList',data);
}

// /****************投诉接口***********************/
// //投诉查询通知
export function rComplainQueryList(data) {
     return fetch.post('/complain/queryList',data);
}



// ****************奖品管理接口***********************/

//添加奖品
export function rAddPrize(data) {
     return fetch.post(url+'/prize/addPrize',data);
}

//编辑奖品
export function rEditPrize(data) {
     return fetch.post('/prize/editPrize',data);
}
//查询奖品列表
export function rPrizeList(data) {
     return fetch.post('/prize/prizeList',data);
}
//删除列表
export function rDeletePrize(data) {
     return fetch.post('/prize/deletePrize',data);
}


// ****************活动数据权限***********************/

//添加奖品
export function rUserActivityAdd(data) {
     return fetch.post('/data-auth/add',data);
}

//查询奖品列表
export function rUserActivitylist(data) {
     return fetch.post('/user-activity/list',data);
}
//删除列表
export function rUserActivityDelete(data) {
     return fetch.post('/data-auth/delete/'+data);
}


//分页查询用户活动关系
export function rBindeUsersList(data) {
     return fetch.post('/data-auth/bind/users',data);
}
//分页搜索用户活动关系
export function rBindeUsersSeachList(data) {
     return fetch.post('/data-auth/fuzzy-query/bind/users',data);
}

//分页查询未绑定用户关系
export function rUnbindeUsersList(data) {
     return fetch.post('/data-auth/unbind/users',data);
}
//分页查询搜索未绑定用户关系
export function rUnbindeUsersSeachList(data) {
     return fetch.post('/data-auth/fuzzy-query/unbind/users',data);
}






//列表值修改
export function rListvalueEdit(data) {
     return fetch.post('/param/listvalue/edit',data);
}
//列表值删除
export function rListvalueEditRemove(data) {
     return fetch.post('/param/listvalue/remove',data);
}

//中奖流水
export function rQueryPagePrizeUserLog(data) {
     return fetch.post('/prize/queryPagePrizeUserLog',data);
}
//下拉奖品列表
export function queryPrizeNameGroupBy(data) {
     return fetch.post('/prize/queryPrizeNameGroupBy',data);
}



//导出中奖记录
export function exportWinRecord(data) {
  return fetch.post('/prize/exportWinningRecord',data);

}
//奖品发放流水
export function rQueryPagePrizeProvideLog(data) {
     return fetch.post('/prize/queryPagePrizeProvideLog',data);
}
//奖品发放失败查看报文
export function queryAwardResponseJson(data) {
     return fetch.post('/prize/queryAwardResponseJson',data);
}



//获取最大抽兑奖码
export function rQueryMaxLotteryCode(data) {
     return fetch.post('/prize/queryMaxLotteryCode',data);
}
//获取最大奖品码
export function rQueryMaxPrizeCode(data) {
     return fetch.post('/prize/queryMaxPrizeCode',data);
}
//单人发奖
export function rPrizePayment(data) {
     return fetch.post('/prize/prizepayment',data);
}

//批量发奖
export function batchPrizePayment(data) {
     return fetch.post('/prize/allprizepayment',data);
}

// ****************模板消息管理***********************/
// 查询模板分页列表
export function rQueryTemplatePageList(data) {
    return fetch.post('/template/queryTemplatePageList',data);
}

//添加模板
export function rAddTemplate(data) {
    return fetch.post('/template/addTemplate',data);
}

//删除模板
export function rDeleteTemplate(data) {
    return fetch.post('/template/deleteTemplate',data);
}

//编辑模板
export function rEditTemplate(data) {
    return fetch.post('/template/editTemplate',data);
}

//查询消息记录列表
export function rQueryMessageLogPageList(data) {
    return fetch.post('/template/queryMessageLogPageList',data);
}

//编辑消息记录
export function rEditMessageLog(data) {
    return fetch.post('/template/editMessageLog',data);
}

//发送模板消息
export function rPostMessage(data) {
    return fetch.post('/template/sendMessage',data);
}

//上传文件    /template/uploadUsers

//中止发送
export function rStopSend(data) {
    return fetch.post('/template/stopSend',data);
}

//作废
export function rCancleMessageLog(data) {
    return fetch.post('/template/cancleMessageLog',data);
}

// ****************左边导航菜单***********************/

export function getResourceMenu() {
    return fetch.get("/resource/menu")
}


// ****************用户中心退出***********************/

export function getUserCenterLogout(data) {
    return fetch.post("/userCenter/logout",data)
}


// ****************用户授权参数***********************/
//查询授权参数
export function getqueryAuthParam(data) {
    return fetch.post(url+"/param/auth/queryAuthParam",data)
}
// 保存系统参数
export function getUpdateAuthParam(data) {
    return fetch.post(url+"/param/auth/updateAuthParam",data)
}


// ****************权益查询***********************/
//查询用户权益
export function rQueryUserEquityList(data) {
     return fetch.post("/userequity/queryUserEquityList",data)
 }

 //权益流水查询
export function rQueryEquityLogList(data) {
     return fetch.post("/userequity/queryEquityLogList",data)
 }
 // 补发权益
 export function getReissueEquity(data) {
     return fetch.post("/userequity/reissueEquity",data)
 }











//用户中心的登录回调
export function rServiceValidate(data) {
     return fetch.post('/userCenter/serviceValidate',data);
}






/*判断对象是否为空*/
export function judgeobj(obj){
  if(Object.keys(obj).length==0){
    return false;
  }else{
    return true;
  }
}

/*显示菜单并改变名称*/
export function showmenu(path,name){
  asyncRouterMap.forEach(item=>{
    if(item.path===path){
      item.hidden = false;
      item.name = name;
    }
  });
}

/*显示子菜单并改变名称*/
export function showchildmenu(path,childpath,name){
  asyncRouterMap.forEach(item=>{
    if(item.path===path){
      item.children.forEach(citem=>{
        if(citem.path===childpath){
          citem.hidden = false;
          citem.name = name;
        }
      });
    }
  });
}









// WEBPACK FOOTER //
// ./src/api/bizApi/commonUtil.js